module.exports = __webpack_public_path__ + "img/corner.63910858.png";